<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'mda' | nomenclatura | async}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-segment mode="ios" value="discipulador" [(ngModel)]="mdaTipo" [scrollable]="true" class="segment-gradient-title">
      <ion-segment-button value="discipulador" [ngPlural]="mdas.discipuladores.length">
        <ng-template ngPluralCase="=0">
          <ion-label class="header">
            {{'discipulador' | nomenclatura | async}}
          </ion-label>
        </ng-template>

        <ng-template ngPluralCase="one">
          <ion-label class="header">
            {{'discipulador' | nomenclatura | async}}</ion-label>
        </ng-template>

        <ng-template ngPluralCase="other">
          <ion-label class="header">
            {{'discipulador' | nomenclatura | async}}
          </ion-label>
        </ng-template>
      </ion-segment-button>

      <ion-segment-button value="discipulo" [ngPlural]="mdas.discipulos.length">
        <ng-template ngPluralCase="=0">
          <ion-label class="header">
            {{'discipulo' | nomenclatura | async}}
          </ion-label>
        </ng-template>

        <ng-template ngPluralCase="one">
          <ion-label class="header">
            {{'discipulo' | nomenclatura | async}}
          </ion-label>
        </ng-template>

        <ng-template ngPluralCase="other">
          <ion-label class="header">
            {{'discipulo' | nomenclatura | async}}
          </ion-label>
        </ng-template>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div [ngSwitch]="mdaTipo">
    <div *ngSwitchCase="'discipulador'">
      <div *ngFor="let d of mdas.discipuladores">
        <ion-card-content>
          <ion-list>
            <ion-grid>
              <ion-row>
                <div class="avatar-square">
                  <ion-avatar>
                    <img [src]="d.discipuladorBasic.foto | image:' '" />
                  </ion-avatar>
                </div>

                <ion-col class="ion-align-self-center">
                  <h3 class="item-title bold-2">{{d.discipuladorBasic.nome}}</h3>

                  <div class="item-description">
                    <p class="description-text"><span class="bold-1"> {{'Próx. Encontro' | translate}}:</span> <span> {{
                        (d.proximoEncontro !== null) ?
                        (d.proximoEncontro.data | dateFormat:'dd/MM • HH:mm') : ('Não Informado' | translate)}} </span>
                    </p>
                  </div>
                </ion-col>

                <ion-note *ngIf="userProvider.hasConfig(47) && !modoReduzido" (click)="opcoesMda(d, 'DISCIPULADOR')">
                  <ion-icon name="ellipsis-vertical"></ion-icon>
                </ion-note>
              </ion-row>
            </ion-grid>
          </ion-list>
        </ion-card-content>
      </div>

      <sem-registro *ngIf="!mdas.discipuladores.length"></sem-registro>
    </div>

    <div *ngSwitchCase="'discipulo'">
      <div *ngFor="let d of mdas.discipulos">
        <ion-card-content>
          <ion-list>
            <ion-grid>
              <ion-row>
                <div class="avatar-square">
                  <ion-avatar>
                    <img [src]="d.discipuloBasic.foto | image:' '" />
                  </ion-avatar>
                </div>

                <ion-col class="ion-align-self-center">
                  <h3 class="item-title bold-2">{{d.discipuloBasic.nome}}</h3>

                  <div class="item-description">
                    <p class="description-text"><span class="bold1"> {{'Próx. Encontro' | translate}}: </span> <span> {{
                        (d.proximoEncontro !== null) ?
                        (d.proximoEncontro.data | dateFormat:'dd/MM • HH:mm') : ('Não Informado' | translate)}} </span>
                    </p>
                  </div>
                </ion-col>

                <ion-note *ngIf="userProvider.hasConfig(47) && !modoReduzido" (click)="opcoesMda(d, 'DISCIPULO')">
                  <ion-icon name="ellipsis-vertical"></ion-icon>
                </ion-note>
              </ion-row>
            </ion-grid>
          </ion-list>
        </ion-card-content>
      </div>

      <sem-registro *ngIf="!mdas.discipulos.length"></sem-registro>
    </div>
  </div>
</ion-content>

<ion-footer *ngIf="loaded">
  <ion-grid>
    <ion-row class="ion-justify-content-center">
      <ion-col size="9">
        <ion-button expand="block" class="btn-default" (click)="addDiscipulador()">
          {{'Adicionar' | translate}} {{'discipulo' | nomenclatura | async}}/{{'discipulador' | nomenclatura | async}}
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-footer>